import React from "react";

const IconInfo = (props) => {
  return (
    <svg width={props.width || "22"} height={props.height || "22"} viewBox="0 0 28 28">
      <g dataname="Group 1749" transform="translate(-112 -480)">
        <g dataname="Group 1744" transform="translate(112 479.5)">
          <g
            id="Ellipse_276"
            dataname="Ellipse 276"
            transform="translate(0 0.5)"
            fill="none"
            stroke={props.stroke || "#000"}
            strokeWidth="2"
          >
            <circle cx="14" cy="14" r="13" fill="none" />
          </g>
        </g>
        <g
          id="Group_1745"
          dataname="Group 1745"
          transform="translate(125.5 488.742)"
        >
          <path
            id="Path_9207"
            dataname="Path 9207"
            d="M-10290.5-10570.595v-6.752"
            transform="translate(10291 10582.45)"
            fill="none"
            stroke={props.stroke || "#000"}
            strokeLinecap="round"
            strokeWidth="2"
          />
          <path
            id="Path_9209"
            dataname="Path 9209"
            d="M-10290.5-10576.831v-.516"
            transform="translate(10291 10577.347)"
            fill="none"
            stroke={props.stroke || "#000"}
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconInfo;
